import React, {useState} from 'react';
import styles from './styles.module.scss';
import {Skeleton} from '@chakra-ui/react';
import classNames from 'classnames';
import {ReactComponent as PlayIcon} from 'svg/play-icon.svg';
import {Lock} from 'lucide-react';
import {IOfferItem} from 'types/offers';
import {Link} from 'react-router-dom';
import {APP_PATHS} from '../../../constants';
import DeviceTypeIcon from 'components/device-type-icon';

const OfferCard: React.FC<{data: IOfferItem | null; loading: boolean; isBlurred?: boolean}> = ({data, loading, isBlurred = false}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleClick = () => setIsHovered(true);

  if (isBlurred) {
    return (
      <div
        className={`${styles.wrapper} ${styles.locked} ${isHovered ? styles.hovered : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      >
        <div className={styles.blurredContent}>
          <div className={styles.image}>
            <img src={data?.game_logo} alt={data?.game_name} />
            <DeviceTypeIcon deviceType={data?.platform} />
          </div>
          <div className={styles.title}>{data?.game_name}</div>
          <div className={styles.type}>Game</div>
          <div className={styles.offer}>{data?.total_rewards_value_str}</div>
        </div>
        {isHovered && (
          <div className={styles.hoverContent}>
            <div className={styles.lockIcon}>
              <Lock />
            </div>
            <div className={styles.playText}>Locked Offer</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={`${APP_PATHS.OFFER}/${data?.offer_id}`}
      className={styles.wrapper}
      replace={true}
      state={{from: APP_PATHS.OFFERS}}
    >
      <div className={styles.image}>
        {loading ? (
          <Skeleton height="100%" width="100%" className={classNames(styles.skeleton, styles.absolute)} />
        ) : (
          <>
            <img src={data?.game_logo} alt={data?.game_name} />
            <DeviceTypeIcon deviceType={data?.platform} />
            <div className={styles.hover}>
              <div className={styles.play}>
                <PlayIcon />
              </div>
              <div className={styles.playText}>Start Offer</div>
            </div>
          </>
        )}
      </div>
      <div className={styles.title}>
        {loading ? <Skeleton height="21px" width="100%" className={styles.skeleton} /> : data?.game_name}
      </div>
      <div className={styles.type}>
        {loading ? <Skeleton height="12px" width="100%" className={styles.skeleton} /> : 'Game'}
      </div>
      <div className={styles.offer}>
        {loading ? (
          <Skeleton height="16px" width="50%" className={styles.skeleton} />
        ) : (
          `${data?.total_rewards_value_str}`
        )}
      </div>
    </Link>
  );
};

export default OfferCard;
